import React from 'react'
import { Col, Row, Modal } from 'antd'
import { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'

import { Input } from 'src/components/Formik'
import { Policy, PolicyApprovalRules } from 'src/types'

import * as CSS from './styles'
import SelectPolicyExceptionGroup from './select-policy-exception-group'

import * as Values from '../hierarchy-flows-approvals/values'

interface Props {
  formikProps: FormikProps<PolicyApprovalRules>
  policies: Policy[]
}

export default function HierarchyFlowsApprovalsExceptionModal({
  formikProps,
  policies
}: Props) {
  const { t } = useTranslation()

  const isVisible = Boolean(formikProps.values.policy_approval_rule_id)

  return (
    <Modal
      centered
      closable
      destroyOnClose
      okButtonProps={{
        //@ts-ignore
        'data-test-id': 'hierarchy-flows-approvals-exception'
      }}
      onCancel={() => {
        formikProps.resetForm(Values.initialValues)
      }}
      onOk={() => {
        formikProps.handleSubmit()
      }}
      title={t('web.policies-flow.exception-modal.title')}
      visible={isVisible}
      width={700}
    >
      <Row>
        <Col span={24}>
          <CSS.Title>
            {t('web.policies-flow.exception-modal.approval-rule')}
          </CSS.Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <CSS.Description>
            {t('web.policies-flow.exception-modal.approval-rule-info')}
          </CSS.Description>
        </Col>
      </Row>
      <Row gutter={24}>
        <Col span={6}>
          <Input
            data-test-id="modal-approval-code"
            formikProps={formikProps}
            label="web.tree.node.code"
            name="code"
            placeholder="web.tree.node.code-placeholder"
          />
        </Col>
        <Col span={18}>
          <Input
            data-test-id="modal-approval-name"
            formikProps={formikProps}
            label="web.tree.node.name"
            name="name"
            placeholder="web.tree.node.name-placeholder"
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <CSS.Title>
            {t('web.policies-flow.exception-modal.select-rules')}
          </CSS.Title>
        </Col>
      </Row>
      <SelectPolicyExceptionGroup
        policies={policies}
        formikProps={formikProps}
      />
      <Row>
        <Col span={24}>
          <CSS.Title>
            {t('web.policies-flow.exception-modal.approval-include')}
          </CSS.Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div
            onClick={() => {
              formikProps.setFieldValue(
                'include_original_approvers',
                !formikProps.values.include_original_approvers
              )
            }}
          >
            <CSS.Switch
              checked={formikProps.values.include_original_approvers}
              data-test-id="modal-approval-exception"
            />
            <CSS.Description>
              {t('web.policies-flow.exception-modal.approval-switch')}
            </CSS.Description>
          </div>
        </Col>
      </Row>
    </Modal>
  )
}
